import { ClickAwayListener, Icon, Stack, Tooltip, Typography } from '@mui/material';
import { DropdownSelectRow } from '@schooly/components/filters';
import { useFlag } from '@schooly/hooks/use-flag';
import { FC } from 'react';

import { ChevronDownSmallIcon } from '../assets/icons';

type TooltipMenuOption = {
  value: string;
  onClick: () => void;
};

type TooltipMenuProps = {
  currentValue: string;
  options: TooltipMenuOption[];
};

export const TooltipMenu: FC<TooltipMenuProps> = ({ options, currentValue }) => {
  const [isOpen, open, close] = useFlag();
  return (
    <ClickAwayListener onClickAway={close}>
      <Tooltip
        open={isOpen}
        arrow={false}
        placement="top-start"
        componentsProps={{
          tooltip: {
            sx: () => ({
              minWidth: 215,
              padding: 1,
              marginBottom: '2px !important',
              borderRadius: '4px',
            }),
          },
        }}
        title={
          <Stack gap={0.5}>
            {options.map((option) => (
              <DropdownSelectRow
                key={option.value}
                isSelected={option.value === currentValue}
                onClick={() => {
                  option.onClick();
                  close();
                }}
              >
                {option.value}
              </DropdownSelectRow>
            ))}
          </Stack>
        }
      >
        <Stack
          direction="row"
          alignItems="center"
          gap={1}
          sx={{
            cursor: 'pointer',
            '.MuiIcon-root': {
              color: isOpen ? 'primary.main' : 'common.grey2',
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            },
            '.MuiTypography-root': {
              color: isOpen ? 'primary.main' : 'common.grey2',
            },
            '&:hover': {
              '.MuiIcon-root': {
                color: 'primary.main',
              },
              '.MuiTypography-root': {
                color: 'primary.main',
              },
            },
            width: 'fit-content',
          }}
          onClick={isOpen ? close : open}
        >
          <Typography variant="h3" pl={1.75}>
            {currentValue}
          </Typography>

          <Icon onClick={isOpen ? close : open}>
            <ChevronDownSmallIcon />
          </Icon>
        </Stack>
      </Tooltip>
    </ClickAwayListener>
  );
};
